import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppcolorService } from './appcolor.service';
import { NgxMatColorPickerInput, Color } from '@angular-material-components/color-picker';
import { OptionService } from './../../options/option.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { UsersService } from 'src/app/options/users/users.service';
import { ExportexcelService } from 'src/app/reports/exportexcel.service';


@Component({
  selector: 'app-appcolor',
  templateUrl: './appcolor.component.html',
  styleUrls: ['./appcolor.component.css']
})
export class AppcolorComponent implements OnInit {

  colorCtr!: FormControl;
  color: ThemePalette = 'primary';
  touchUi = false;
  disabled = false;
  spinnerOverlay = false;
  hexCode: any;
  enableQr = false;
  countCards!: number;
  constructor(private service: AppcolorService,
    private userService: UsersService,
    private excelService: ExportexcelService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private optionService: OptionService) { }

  ngOnInit(): void {
    this.get();
    this.getSystemSettings();
  }

  get() {
    this.service.get().subscribe(data => {

      this.hexCode = "#" + data["primaryColor"]
    });
  }


  save() {
    console.log(this.hexCode);
    this.spinnerOverlay = true;
    let obj = {
      "id": 1,
      "primaryColor": this.hexCode.hex
    }

    this.service.Update(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.openSnackBar("Internal server error", 'snackBarError');
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

  getSystemSettings() {
    this.optionService.getSystemSettings("Cards_Count_Email").subscribe(data => {
      this.countCards = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });

    this.optionService.getSystemSettings("Enable_QR").subscribe(data => {
      this.enableQr = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });
  }

  updateSystemSettings() {

    var obj = {
      "key": "Cards_Count_Email",
      "value": this.countCards
    }

    this.optionService.updateSystemSettings(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
    },
      error => {
        console.log(error);
      })
  }

  saveCardCountNotif() {
    this.updateSystemSettings();
  }

  updatePyticCategory() {
    this.spinnerOverlay = true;
    this.optionService.updatePyticCategory().subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  updatePyticSubCategory() {
    this.spinnerOverlay = true;
    this.optionService.updatePyticSubCategory().subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  updatePyticProduct() {
    this.spinnerOverlay = true;
    this.optionService.updatePyticProduct().subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  EnableQr(event: MatSlideToggleChange) {

    this.enableQr = event.checked
    this.spinnerOverlay = true;
    var obj = {
      "key": "Enable_QR",
      "value": this.enableQr ? true : false
    }

    this.optionService.updateSystemSettings(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })

  }

  updateEfwateercome() {
    this.spinnerOverlay = true;
    this.optionService.updateEfwateercome().subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  balanceDownload() {
    this.userService.getUsersBalance().subscribe(data => {
      this.excelService.exportAsExcelFile(data, "users_balance");
    },
      error => {
        console.log(error)
      })
  }

  productCardsDownload() {
    this.service.getAvailableProductCards().subscribe(data => {
      this.excelService.exportAsExcelFile(data, "Product_Cards");
    },
      error => {
        console.log(error)
      })
  }

}
